import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchesComponent } from './batches.component';
import {
  ViewBatchComponent,
  CreateBatchComponent,
  EditBatchMailingComponent,
  BatchMailingCardComponent,
  ViewDepartureAttachmentsComponent,
  BatchListComponent,
  AddBatchMailingComponent,
} from './pages';

const routes: Routes = [
  {
    path: '',
    component: BatchesComponent,
    children: [
      {
        path: '',
        component: BatchListComponent,
      },
      {
        path: 'create',
        component: CreateBatchComponent,
      },
      {
        path: ':id/create',
        component: AddBatchMailingComponent,
      },
      {
        path: ':id/edit',
        component: EditBatchMailingComponent,
      },
      {
        path: ':id/view-batch',
        component: ViewBatchComponent,
      },
      {
        path: ':id/departure-card',
        component: BatchMailingCardComponent,
      },
      {
        path: ':id/view-departure-attachments',
        component: ViewDepartureAttachmentsComponent,
      },
      {
        path: ':id/created/view-departure-attachments',
        component: ViewDepartureAttachmentsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BatchesRoutingModule {}
